import moment from 'moment-timezone';

export default function dateTimeFormat(dateString: Date, options?: any): string {
  return new global.Intl.DateTimeFormat('en-us', options).format(dateString);
}

/**
 *
 * @param date a date string in the format of 'YYYY-MM-DD' by default
 * @param targetFormat the format to convert the date to
 * @param fromFormat the format of the date string
 * @returns a date string in the targetFormat
 */
export function userReadableDateTimeFromFormatToTargetFormat(
  date: Date | string,
  targetFormat = 'MMMM D, YYYY [at] h:mm A',
  fromFormat = 'YYYY-MM-DD hh:mm:ss'
) {
  return moment.utc(date, fromFormat).tz(moment.tz.guess()).format(targetFormat);
}

// returns a string formatted like this: August 08, 2022 at 7:00 PM PDT
// using the timezone moment thinks the user is in
export function userReadableDateYearTimeFormatLocalTZ(dateTime: string) {
  return userReadableDateTimeFromFormatToTargetFormat(dateTime, 'MMMM DD, YYYY [at] LT z');
}

const getCalendarFormat = () => {
  return {
    sameDay: '[Today] [at] hh:mm a',
    nextDay: '[Tomorrow] [at] hh:mm a',
    nextWeek: 'ddd [•] MMM DD[,] YYYY [at] hh:mm a',
    lastDay: '[Yesterday] [at] hh:mm a',
    lastWeek: '[Last] ddd [•] MMM DD[,] YYYY [at] hh:mm a',
    sameElse: 'ddd [•] MMM DD[,] YYYY [at] hh:mm a',
  };
};
// returns a string formatted like the strings represented in getCalendarFormat above
export function userReadableCalendarDate(dateTime: string) {
  return moment(dateTime).tz(moment.tz.guess()).calendar(undefined, getCalendarFormat());
}

export function utcDateFormat(dateTime: string) {
  return moment.utc(dateTime).format('MMM D YYYY');
}
